import { FaEdit, FaTrash } from "react-icons/fa";
import { Link } from "react-router-dom";

export default function EventCard({
    handleEventDelete,
    id,
    title,
    imageUrl,
    status,
}) {
    return (
        <>
            <div
                style={{
                    width: "100%",
                    textAlign: "center",
                }}
                className={`card ${
                    status === "upcoming"
                        ? "has-background-success-light"
                        : "has-background-danger-light"
                }`}
            >
                <div className="card-image">
                    <figure className="image is-square">
                        <img
                            style={{
                                width: "100%",
                                objectFit: "scale-down",
                            }}
                            src={imageUrl}
                            alt="Event"
                        />
                    </figure>
                </div>

                <div className="card-content">
                    <div className="media">
                        <div className="media-content">
                            <h1 className="title is-4">{title}</h1>
                        </div>
                    </div>
                </div>
                <footer className="card-footer">
                    <Link
                        to={`/admin/events/edit/${id}`}
                        className="button card-footer-item"
                    >
                        <FaEdit color="green" />
                    </Link>
                    <button
                        className="button card-footer-item"
                        onClick={() => handleEventDelete(id)}
                    >
                        <FaTrash color="tomato" />
                    </button>
                </footer>
            </div>
        </>
    );
}
